import styled from "styled-components";
import BigNumber from "bignumber.js";
import {
    Text,
    useMatchBreakpoints,
    TokenPairImage as UITokenPairImage,
} from "@pancakeswap/uikit";
import Balance from "components/Balance";
import { TokenPairImage } from "components/TokenImage";
import drivenx from "../../../../../assets/images/drivenx.png";
import bnb from "../../../../../assets/images/bnb.png";
import { Avatar, Box } from "@mui/material";
import BaseCell, { CellContent } from "views/Pools/components/PoolsTable/Cells/BaseCell";

interface FarmNameCellProps {
    pool: any;
}

const StyledCell = styled(BaseCell)`
  flex: 5;
  min-width: 185px;
  display: flex;
  flex-direction: row;
  padding-left: 5px;
  align-items: center;
  /* padding-top: 40px; */
  ${({ theme }) => theme.mediaQueries.sm} {
    /* flex: 1 0 300px; */
    padding-left: 5px;
    /* width:100px; */
  }
`;
const Fees = styled.div`
 padding-top : 2px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: start;
`;

const FarmNameCell: React.FC<FarmNameCellProps> = ({ pool }) => {
    const { isMobile } = useMatchBreakpoints();
    // const stakingTokenSymbol = stakingToken.symbol;
    // const earningTokenSymbol = earningToken.symbol;

    // let title: React.ReactNode = `${"Earn"} ${earningTokenSymbol}`;
    // let subtitle: React.ReactNode = `${"Stake"} ${stakingTokenSymbol}`;

    // }

    return (
        <StyledCell role="cell">
            {/* <img src={pancake} alt="pancake" /> */}
            {/* <img src={drivenx} width="40px" height="40px" alt="drivenx" border-radius="12px !important"/> */}
            <Box sx={{ maxHeight: '40px', maxWidth: '40px', position: 'relative', width: '100%' }}>
                <Box sx={{ position: 'absolute', width: '82%', inset: { xs: '-31px -1px -17px 7px', sm: '-17px 0px 0px 10px', md: 'auto -1px -26px auto', lg: 'auto -1px -26px auto' }, zIndex: '6', maxHeight: '40px', maxWidth: '40px' }}>
                    <Avatar sx={{ width: "40px", height: "40px", borderRadius: "50%", mt: { xs: '10px', sm: '0px', md: '0px', lg: '0px', xl: '0px' }, border: '1px solid', borderColor: '#00FED9' }} src={drivenx} alt="drivenx" variant="rounded"></Avatar>
                </Box>
                <Box sx={{ position: 'absolute', width: '50%', inset: { xs: '-11px auto auto 0px', sm: '-21px auto auto 3px', md: '-18px auto auto 0px', lg: '-18px auto auto 0px' }, zIndex: '5', maxHeight: '20px', maxWidth: '20px', mt: { xs: '-15px', sm: '0px', md: '0px', lg: '0px' } }}>
                    <img style={{ width: "20px", height: "20px", borderRadius: "50%", border: '1px solid', borderColor: '#00FED9' }} src={bnb} alt="bnb" />
                </Box>
            </Box>
            {/* <Avatar sx={{ width: "40px", height: "40px", borderRadius: "50%" }} src={drivenx} alt="drivenx" variant="rounded"></Avatar> */}
            <CellContent>
                <Box sx={{ ml: 2 }}>

                    <Text
                        lineHeight={1}
                        fontSize="16px"
                        fontWeight={400}
                        color="#00FED9"
                    >
                        {pool.token0Symbol}-{pool.token1Symbol}
                    </Text>


                </Box>
            </CellContent>
        </StyledCell>
    );
};

export default FarmNameCell;
